/// Appelé uniquement sur la page d'accueil des listes mariages, pacs et cadeaux
class Accueil extends ListeMariage {
	/// Il s'agit de la fonction appelée sur chacune des pages du tunnel
	initialize() {
		let self = this;

		super.initialize();
		const form = new Formulaire();

		/// les modales d'information
		let btns = document.querySelectorAll('[data-modal="modalInfoListe"]');
		btns.forEach(el => {
			el.addEventListener('click', function (element) {
				self.modalInfo(element, 'modalInfoListe');
			})
		})

		document.getElementById('formParticipation').addEventListener('submit', function (ev) {
			ev.preventDefault();
			self.postRechercheListe(self.config.urlRechercheListe)
		});

		let arrayIdForms = ['formConsultation', 'formParticipation'];
		arrayIdForms.forEach(id => form.initialize(id))

		// Switch recherche liste
		self.rechercheListe(this.config.nameRechercheCritere);
	}
	modalInfo(element, template) {
		let title = element.target.dataset.title || element.target.parentElement.firstChild.textContent.trim();
		let list = element.target.dataset.liste || element.target.parentElement.firstChild.textContent.trim();
		let templateBlock = document.getElementById(template);
		let listClass = templateBlock.classList;

		let content = templateBlock.innerHTML;
		content = content.replaceAll('{{}}', list);
		document.getElementById('popupCancelButton') !== null && document.getElementById('popupCancelButton').remove();
		modalPopup.init(content, title, '', '');
		document.querySelector(modalPopup.items.popupModal).classList.add(listClass);
	}

	rechercheListe(inputHiddenName) {

		let critereRechercheSelector = document.getElementById(inputHiddenName);
		let btnsToggle = document.querySelectorAll('button[data-hiddenRechercheCritere]');
		let critereActif = critereRechercheSelector.value;

		btnsToggle.forEach(el => {
			/// Event click
			el.addEventListener('click', function (element) {
				// On vide la value de l'input
				document.getElementById('txtWeddingListReference').value = '';

				// On met la bonne valeur à l'input hidden
				critereRechercheSelector.value = el.dataset.hiddenrecherchecritere

				// On raffiche les boutons et l'on masque celui sur lequel on a cliqué
				btnsToggle.forEach(btn => btn.style.display = 'initial');
				element.target.style.display = 'none';
				// On masque tous les libellés et l'on affiche celui correspondant à la value du champ hidden
				document.querySelectorAll('[data-field]').forEach(libelle => libelle.style.display = 'none');
				document.querySelector(`[data-field="${el.dataset.hiddenrecherchecritere}"]`).style.display = 'initial';

			});

			if (el.dataset.hiddenrecherchecritere === critereRechercheSelector.value) {
				el.style.display = 'none';
				document.querySelector(`[data-field="${el.dataset.hiddenrecherchecritere}"]`).style.display = 'initial';
			} else {
				el.style.display = 'initial';
				document.querySelector(`[data-field="${el.dataset.hiddenrecherchecritere}"]`).style.display = 'none';
			}
		});
	}

	postRechercheListe(url) {
		let inputRef = document.getElementById('txtWeddingListReference'),
			valRef = inputRef.value,
			typeRef = document.getElementById('hiddenRechercheCritere').value;
		inputRef.classList.remove('error');

		if (valRef != "" && valRef != null && valRef != undefined) {
			let data = {
				typeRecherche: $("#hiddenRechercheCritere").val(),
				value: valRef
			}
			fetch(url, {
					method: 'POST',
					body: new URLSearchParams(data)
				})
				.then((resp) => {
					return resp.text();
				})
				.then((html) => {
					if (typeRef === 'name') {
						document.getElementById('listeCadeauRes').classList.remove('validation-error');
						document.getElementById('listeCadeauRes').innerHTML = html;
					} else {
						try {
							let obj = JSON.parse(html),
								urlListe = obj.url;
							window.location.href = urlListe;
						} catch (e) {
							console.error(e)
							document.getElementById('listeCadeauRes').classList.add('validation-error');
							document.getElementById('listeCadeauRes').innerHTML = `Une erreur s'est produite. Avez-vous correctement renseigné le numéro de liste ?`
							return false;
						}
						return true;
					}
				});

		} else {
			inputRef.classList.add('error');
		}
	}
}